module.exports = __webpack_public_path__ + "images/icons_v2/help-outlined-d149b203.svg";